import { Injectable, inject } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth/auth.service';
import { AlertaService } from '../../shared/utils/alerta.service';
import { HANDLE_HTTP_ERROR_LOCALLY } from '../http/http-context-tokens';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private readonly alerta = inject(AlertaService);

  constructor(private authService: AuthService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.authService.logout();
        }

        // Status 2xx aqui significa resposta bem-sucedida que o Angular não conseguiu interpretar
        // — quase sempre `responseType` errado. É defeito de integração, não algo que o cidadão
        // possa resolver, então vai para o console em vez de virar um modal de erro.
        if (error.status >= 200 && error.status < 300) {
          console.error(
            `Resposta ${error.status} de ${request.url} não pôde ser interpretada.`,
            error.error
          );

          return throwError(() => error);
        }

        if (!request.context.get(HANDLE_HTTP_ERROR_LOCALLY)) {
          this.alerta.fechar();

          const apiMessage = error.error?.message || error.error?.title || 'Erro desconhecido';
          const listaErros = Array.isArray(error.error?.errors)
            ? error.error.errors.join('\n')
            : error.error?.errors || '';

          this.alerta.erro({
            titulo: `Erro ${error.status}`,
            html: listaErros
              ? `<p>${apiMessage}</p><pre class="swal-imap-detalhe">${listaErros}</pre>`
              : apiMessage,
          });
        }

        return throwError(() => error);
      })
    );
  }
}
